import { NietToegewezenKlussen } from "@personeel/components/Werklijnen/Personeelsdiensten/NietToegewezenKlussen.tsx";
import { PersoneelsdienstContainer } from "@personeel/components/Werklijnen/Personeelsdiensten/Personeelsdienst/PersoneelsdienstContainer.tsx";
import { PersoneelsdienstenModel } from "@personeel/models/PersoneelsdienstenModel.ts";
import { usePersoneelsdienstenStore } from "@personeel/stores/PersoneelsdienstenStore.ts";

interface IPersoneelsDiensten {
  scale: number;
}

export function Personeelsdiensten({ scale }: Readonly<IPersoneelsDiensten>) {
  const personeelsdiensten = usePersoneelsdienstenStore((state) => state.personeelsdiensten);

  return (
    <>
      <NietToegewezenKlussen scale={scale} />

      {personeelsdiensten.map((dienstNummerData: PersoneelsdienstenModel) => {
        return (
          <PersoneelsdienstContainer
            key={dienstNummerData.id}
            dienst={dienstNummerData}
            scale={scale}
          />
        );
      })}
    </>
  );
}
